/**************************************************
 * Nombre:       Barra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import BarraPc from "./BarraPc";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import BarraCell from "./BarraCell";
import {useEffect, useState} from "react";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";

const Barra = () => {
    const {masSM} = useResponsive()
    const [valor,setValor] = useState(0)

    useEffect(() => {
        obtenerDoc('configuraciones', 'generales').then((dox) =>{
            if (dox.res){
                setValor(dox.data.valor)
            }
        })
    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            {masSM ?

                <BarraPc valor={valor}/>

                :

                <BarraCell valor={valor}/>


            }


        </Grid>
    )

}
export default Barra    